import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import AIReviewClaimDetails from "./AIReviewClaimDetails";
import ImageZoom from "../claimDetails/imageZoom";
import RightPanel from "../claimDetailsNew/rightPanel";
import Utils from "../../utility";
import {
  getRepairDetailsRecord,
  getImagesRepair,
  postRepairClaimFeedback,
  updateRepairFeedback
} from "../../services/zbrainConnectorService";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Dropdown from "../../common/components/dropdown";
import AlertModal from "../../common/components/popup/alertPopup";

const AIReviewClaimDetailsComponent = () => {
  const navigate = useNavigate();
  const [openImage, setImagePopup] = useState({
    popup: false,
    allImages: [],
    idx: null
  });
  const [openReasonPopup, setOpenReasonPopup] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [componentType, setComponentType] = useState("TIRE");
  const user = useSelector((state) => state.user);
  const location = useLocation();
  const [feedbackData, setFeedbackData] = useState({});
  const [feedbackId, setFeedbackId] = useState(null);
  const [refractorImages, setRefractorImages] = useState([]);
  const [versions, setVersions] = useState([]);
  const [checkFeedback, setCheckFeedback] = useState({
    questionText: "",
    systemResult: "",
    feedback: "",
    comment: "",
    feedbackType: ""
  });
  const params = new URLSearchParams(location.search);
  const getVersion = params.get("version") || undefined;

  const [componentFeedback, setComponentFeedback] = useState({
    component: "",
    componentName: "",
    questionText: "",
    systemResult: "",
    feedback: "",
    comment: "",
    feedbackType: ""
  });

  const { claimNumber } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [images, setImages] = useState({});
  const [questions, setQuestions] = useState([]);
  const timeoutRef = useRef(null);
  const [localData, setLocalData] = useState([]);
  const [selectedVersion, setSelectedVersion] = useState(getVersion || "");

  const fetchDetails = async (
    retryCount = 1,
    currentVersion,
    currentClaimNumber
  ) => {
    if (retryCount > 4) return;

    if (retryCount === 1) {
      setLoading(true);
    }

    try {
      let requestData = {};
      if (getVersion || selectedVersion) {
        requestData.version = currentVersion;
      }
      const [error, response] = await Utils.parseResponse(
        getRepairDetailsRecord(currentClaimNumber, requestData)
      );

      if (error || !response) {
        if (error?.response?.status === 500) {
          toast.error("Internal server error");
        } else {
          toast.error(error?.response?.data?.message || "Something went wrong");
        }
        navigate("/claim-list");
        return;
      }
      setData(response);
      setFeedbackData(response?.feedbackDetails);
      if (response?.version === null || response?.version === undefined) {
        setIsOpen(true);
      } else {
        setSelectedVersion(response?.version);
      }
      let highestVersionArray = [];
      for (let i = 1; i <= response.highestVersion; i++) {
        highestVersionArray.push(`${i}`);
      }
      setVersions(highestVersionArray);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleFeedback = async () => {
    try {
      let requesData = {
        claimId: data?.repairFirstClaimId,
        claimNumber: claimNumber,
        createdBy: user?.userId,
        version: getVersion || selectedVersion,
        feedbackBy: {
          userId: user?.userId,
          name: user?.name,
          email: user?.email
        }
      };

      const isElementDataEmpty = Object.values(checkFeedback).every(
        (value) => value === "" || value == null
      );

      if (!isElementDataEmpty) {
        const { feedbackType, ...rest } = checkFeedback;
        if (feedbackType === "commercialUsage") {
          requesData.commercialUsage = [rest];
        } else if (feedbackType === "vinComparison") {
          requesData.vinComparison = [rest];
        } else if (feedbackType === "sameTire") {
          requesData.sameTire = [rest];
        } else if (feedbackType === "decisionStatus") {
          requesData.decisionStatus = [rest];
        }
      }
      const isComponentDataEmpty = Object.values(componentFeedback).every(
        (value) => value === "" || value == null
      );

      if (!isComponentDataEmpty) {
        const { feedbackType, ...rest } = componentFeedback;
        if (feedbackType === "damageResults") {
          requesData.damageResults = [rest];
        } else if (feedbackType === "mandatoryChecks") {
          requesData.mandatoryChecks = [rest];
        } else if (feedbackType === "additionalQuestions") {
          requesData.additionalQuestions = [rest];
        } else if (feedbackType === "sameTire") {
          requesData.sameTire = [rest];
        } else if (feedbackType === "decisionStatus") {
          requesData.decisionStatus = [rest];
        }
      }

      const [error, response] = await Utils.parseResponse(
        postRepairClaimFeedback(requesData)
      );

      if (error || !response) {
        if (error?.response?.status === 500) {
          toast.error("Internal server error");
        } else {
          toast.error(error?.response?.data?.message);
        }
        return;
      }

      setFeedbackData(response);

      setCheckFeedback({
        questionText: "",
        systemResult: "",
        feedback: "",
        comment: "",
        feedbackType: ""
      });

      setComponentFeedback({
        componentName: "",
        questionText: "",
        systemResult: "",
        feedback: "",
        comment: "",
        feedbackType: ""
      });
      toast.success("Feedback added successfully");

      setFeedbackId(response?._id);
      setOpenReasonPopup(null);
    } catch (e) {
      console.error(e);
    }
  };

  const handleUpdateFeedback = async () => {
    try {
      let requesData = {
        claimId: data?.repairFirstClaimId,
        claimNumber: claimNumber,
        feedbackType:
          checkFeedback?.feedbackType || componentFeedback.feedbackType,
        createdBy: user?.userId,
        version: getVersion || selectedVersion,
        feedbackBy: {
          userId: user?.userId,
          name: user?.name,
          email: user?.email
        }
      };
      const isElementDataEmpty = Object.values(checkFeedback).every(
        (value) => value === "" || value == null
      );

      if (!isElementDataEmpty) {
        const { feedbackType, ...rest } = checkFeedback;
        if (feedbackType === "commercialUsage") {
          requesData.commercialUsage = [rest];
        } else if (feedbackType === "vinComparison") {
          requesData.vinComparison = [rest];
        } else if (feedbackType === "sameTire") {
          requesData.sameTire = [rest];
        } else if (feedbackType === "decisionStatus") {
          requesData.decisionStatus = [rest];
        }
      }
      const isComponentDataEmpty = Object.values(componentFeedback).every(
        (value) => value === "" || value == null
      );

      if (!isComponentDataEmpty) {
        const { feedbackType, ...rest } = componentFeedback;
        if (feedbackType === "damageResults") {
          requesData.damageResults = [rest];
        } else if (feedbackType === "mandatoryChecks") {
          requesData.mandatoryChecks = [rest];
        } else if (feedbackType === "additionalQuestions") {
          requesData.additionalQuestions = [rest];
        } else if (feedbackType === "sameTire") {
          requesData.sameTire = [rest];
        } else if (feedbackType === "decisionStatus") {
          requesData.decisionStatus = [rest];
        }
      }
      const [error, response] = await Utils.parseResponse(
        updateRepairFeedback(
          requesData,
          data?.feedbackDetails?._id || feedbackId
        )
      );

      if (error || !response) {
        if (error?.response?.status === 500) {
          toast.error("Internal server error");
        } else {
          toast.error(error?.response?.data?.message);
        }
        return;
      }

      setFeedbackData(response);

      setCheckFeedback({
        questionText: "",
        systemResult: "",
        feedback: "",
        comment: "",
        feedbackType: ""
      });

      setComponentFeedback({
        componentName: "",
        questionText: "",
        systemResult: "",
        feedback: "",
        comment: "",
        feedbackType: ""
      });
      toast.success("Feedback updated successfully");

      setOpenReasonPopup(null);
    } catch (e) {
      console.error(e);
    }
  };

  const getInspectionImages = async () => {
    try {
      const requesData = {
        version: getVersion || selectedVersion
      };
      const [error, response] = await Utils.parseResponse(
        getImagesRepair(claimNumber, requesData)
      );

      if (error || !response) {
        if (error?.response?.status === 500) {
          //   toast.error("Internal server error");
        } else {
          toast.error(error?.response?.data?.message);
        }
        return;
      }
      setImages(response);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getInspectionImages();
    // eslint-disable-next-line
  }, [getVersion]);

  useEffect(() => {
    fetchDetails(1, getVersion || selectedVersion, claimNumber);
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
    // eslint-disable-next-line
  }, [getVersion]);

  useEffect(() => {
    const mappedData = Object.entries(images ?? {})
      // keep only keys that have a non-empty array
      .filter(([, arr]) => Array.isArray(arr) && arr.length > 0)
      // flatten to items and drop ones without a valid URL
      .flatMap(([key, arr]) =>
        arr
          .filter((img) => !!img?.signedObjectUrl)
          .map((image) => ({
            image: image.signedObjectUrl,
            type: key,
            componentName: image.componentName || key,
            componentCode: image.componentCode,
            id: image.documentId,
            modifiedOn: image?.tagDetails?.modifiedOn,
            tag: image?.tagDetails?.tag
          }))
      );

    setRefractorImages(mappedData);
  }, [images]);

  const handleBackNavigation = () => {
    // navigate(`/inspection-claims${location.search}&details=true`);
    navigate(-1);
  };

  const handleVersionChange = (selectedVersion) => {
    const params = new URLSearchParams(location.search);

    params.set("version", selectedVersion);

    navigate({
      pathname: `/inspection-claims/${claimNumber}`,
      search: `?${params.toString()}`
    });

    setSelectedVersion(selectedVersion);
  };

  if (loading) {
    return (
      <div className="flex h-75vh items-center justify-center">
        <div className="loader "></div>
      </div>
    );
  }
  return (
    <div>
      <div className="flex justify-between">
        <div className="flex items-center gap-2">
          <img
            onClick={handleBackNavigation}
            src="/images/left-arrow.svg"
            alt=""
            className="cursor-pointer"
          />
          <span className="font-InterBold text-ft25-30 text-black-10">
            Claim Report
          </span>
        </div>
        <Dropdown
          width={"min-w-31"}
          text={"Version"}
          value={selectedVersion}
          list={versions}
          handleSelect={handleVersionChange}
          // setCurrentPage={setCurrentPage}
        />
      </div>
      <div className="flex w-full gap-4 pt-6">
        <div className="w-80per">
          <AIReviewClaimDetails
            imagesData={refractorImages}
            setImagePopup={setImagePopup}
            handleFeedback={handleFeedback}
            handleUpdateFeedback={handleUpdateFeedback}
            openReasonPopup={openReasonPopup}
            setOpenReasonPopup={setOpenReasonPopup}
            data={data}
            setQuestions={setQuestions}
            questions={questions}
            setComponentType={setComponentType}
            componentType={componentType}
            feedbackData={feedbackData}
            setComponentFeedback={setComponentFeedback}
            componentFeedback={componentFeedback}
            setCheckFeedback={setCheckFeedback}
            checkFeedback={checkFeedback}
          />
        </div>
        <div className="w-20per">
          <RightPanel
            setImagePopup={setImagePopup}
            imagesData={refractorImages}
            handleFeedback={handleFeedback}
            handleUpdateFeedback={handleUpdateFeedback}
            openReasonPopup={openReasonPopup}
            setOpenReasonPopup={setOpenReasonPopup}
            data={data}
            setComponentType={setComponentType}
            componentType={componentType}
            feedbackData={feedbackData}
            isForRepair={true}
          />
        </div>
      </div>
      {openImage.popup && (
        <ImageZoom
          openImage={openImage}
          setImagePopup={setImagePopup}
          data={questions}
          claimData={data}
          claimModel="repairfirstclaims"
          localData={localData}
          setLocalData={setLocalData}
        />
      )}
      <AlertModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        message={
          <>
            <p>
              This claim includes override decisions from an earlier system
              version. Since this data may not map accurately to the current
              system values, feedback is disabled for this claim.
            </p>
          </>
        }
      />
    </div>
  );
};

export default AIReviewClaimDetailsComponent;
